<div class="panel" [ngClass]="{'panel-alt': altTheme}">
  <span class="panel-icon">
    <i class="icon {{ iconClass }}" aria-hidden="true"></i>
  </span>

  <h2>{{ label }}</h2>
  <span class="number">{{ value }}</span>
  <span class="number-alt" *ngIf="secondaryValue !== undefined && secondaryValue !== null">({{secondaryValue}})</span>
</div>
